module.exports = __webpack_public_path__ + "img/play.e1b5751c.png";